import { useMemo } from 'react';
import styled from 'styled-components';
import { theme } from '@frameio/vapor';
import { useDraggingIds } from '../../../operations';
import { AssetTrail } from './AssetTrail';

export const DraggableAssetOverlay = () => {
  const { draggingIds, active } = useDraggingIds();
  const trailIds = useMemo(
    () =>
      active?.id
        ? [
            active.id,
            ...Array.from(draggingIds)
              .slice(0, MAX_TRAIL_COUNT - 1)
              .filter((id) => id !== active.id),
          ]
        : [],
    [active?.id, draggingIds]
  );
  const shouldRender = active?.id;

  return (
    <>
      {shouldRender ? (
        <>
          <AssetTrail totalCount={draggingIds.size} trailIds={trailIds} />
          <OverlayCurtain aria-hidden={true} />
        </>
      ) : null}
    </>
  );
};
const MAX_TRAIL_COUNT = 4;

const OverlayCurtain = styled.div`
  cursor: grabbing;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${theme.zIndices.popover};
`;
